// extracted by mini-css-extract-plugin
export default {"container":"style_container__tqRWV","pageIndex":"style_pageIndex__l8qlq","arrow":"style_arrow__J7cfZ"};